import { inject, injectable } from '~/container'
import { PuLangFetch } from '~/lang/utils/pulangfetch'
import { Faq, faqSchema, FaqStandalone, faqStandaloneSchema } from './schemas'
import { FaqRepository, FaqResponse, FaqStandaloneResponse } from './types'

@injectable()
export class FaqRepositoryFetch implements FaqRepository {
  @inject(PuLangFetch)
  private puLangFetch: PuLangFetch

  async getAll(langCode: string): Promise<Faq[]> {
    const faqs = await this.puLangFetch.fallbackFetch<FaqResponse[]>(
      langCode,
      '/about/faq/?json',
    )
    return faqs.map((faq) => faqSchema.parse(faq))
  }

  async getStandaloneBySlug(
    langCode: string,
    slug: string,
  ): Promise<FaqStandalone> {
    const faq = await this.puLangFetch.fallbackFetch<FaqStandaloneResponse>(
      langCode,
      `/about/faqs/${slug}/?json`,
    )
    return faqStandaloneSchema.parse(faq)
  }
}
